/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { IntegrationSchema } from './integration';
import { Noop } from '.';

export const enum PortalTypes {
  ELASTIC_SEARCH_OVERLAY = 'ELASTIC_SEARCH_OVERLAY',
  DISCOVERY_SEARCH_OVERLAY = 'DISCOVERY_SEARCH_OVERLAY',
  SEARCH_CHOICE_OVERLAY = 'SEARCH_CHOICE_OVERLAY',
  CHANNEL_OVERLAY = 'CHANNEL_OVERLAY',
  CUSTOM_SERVICE_OVERLAY = 'CUSTOM_SERVICE_OVERLAY',
  MILVUS_OVERLAY = 'MILVUS_OVERLAY'
}

export type Portal =
  | {
      type: PortalTypes.CHANNEL_OVERLAY;
      props: {
        onClose?: Noop;
        environmentId: string;
        type: string;
        assistantId: string;
        catalogItemId?: string;
        catalogItem?: IntegrationSchema;
        defaultTab?: number;
      };
    }
  | {
      type: PortalTypes.DISCOVERY_SEARCH_OVERLAY;
      props: {
        onClose?: Noop;
        environmentId: string;
        templateId?: string;
        skillId?: string;
      };
    }
  | {
      type: PortalTypes.ELASTIC_SEARCH_OVERLAY;
      props: {
        onClose?: Noop;
        skillId: string;
        environmentId: string;
      };
    }
  | {
      type: PortalTypes.SEARCH_CHOICE_OVERLAY;
      props: {
        onClose?: Noop;
        environmentId: string;
      };
    }
  | {
      type: PortalTypes.CUSTOM_SERVICE_OVERLAY;
      props: {
        onClose?: Noop;
        skillId: string;
        environmentId: string;
      };
    }
  | {
      type: PortalTypes.MILVUS_OVERLAY;
      props: {
        onClose?: Noop;
        skillId: string;
        environmentId: string;
      };
    };
